window.riceburritoCart = [];

// 測試站
// const API_BASE = 'https://pickup.twcanhelp.me';
// 正式站
const API_BASE = "https://pickup.riceburrito.com";

// Get the modal
const modal = document.querySelector("#modalCheck");

// Get the <span> element that closes the modal
const spanClose = document.querySelector(".close");

// Get modal's check button
const check = document.querySelector(".modal-check");

// Check modal is open
let modalIsOpen = false;

// Get "CHECK OUT" button with Cart's page
const submit = document.querySelector(".cart__submit");

// Get store cards
const storeCards = document.querySelector(".store-cards");

// Get store time select
const storeTimeSelect = document.querySelector(".store-time-select");

const storeTimeGroup = document.querySelector(".store-time-group");

// Get input with store-id and store-date
const inputStoreId = document.querySelector('[name="attributes[store_id]"]');
const inputStoreName = document.querySelector(
  '[name="attributes[store_name]"]'
);
const inputStoreAddress = document.querySelector(
  '[name="attributes[store_address]"]'
);
const inputMaxWeight = document.querySelector(
  '[name="attributes[max_weight]"]'
);
const inputPickupDateTime = document.querySelector(
  '[name="attributes[pickup_date_time]"]'
);
const inputPickupDate = document.querySelector(
  '[name="attributes[pickup_date]"]'
);
const inputPickupTime = document.querySelector(
  '[name="attributes[pickup_time]"]'
);
const inputTotalWeight = document.querySelector(
  '[name="attributes[total_weight]"]'
);

// Get invalid text
const storeCardsInvalidText = document.querySelector(
  ".store-cards-invalid-text"
);
const storeTimeInvalidText = document.querySelector(".store-time-invalid-text");

// Get Sold out text & exceed max weight text
const storeSoldOutText = document.querySelector(".store-time-sold-out-text");
const storeSoldOutPreoderText = document.querySelector(
  ".store-time-sold-out-preorder-text"
);
const storeExceedMaxWeightText = document.querySelector(
  ".store-time-exceed-max-weight-text"
);

const storePickup = document.querySelector(".store-pickup");

const fetchCart = async () => {
  return fetch("/cart.js")
    .then((response) => {
      return response.json();
    })
    .then((state) => {
      return state.items;
    });
};

// Control modal open or close
const triggerModal = (isOpen) => {
  modal.style.display = isOpen ? "none" : "flex";
  modalIsOpen = !isOpen;
};

// When the user clicks anywhere outside of the modal, close it
window.onclick = (event) => {
  if (event.target == modal) {
    triggerModal(modalIsOpen);
  }
};

// Jump alert
const alertChooseStore = () => {
  alert("Please select your pickup location. 請先選擇取餐地點");
};

// When the user clicks on <span> (x), close the modal
spanClose.onclick = () => {
  triggerModal(modalIsOpen);
};

// Submit button event
submit.onclick = (e) => {
  // Check modal is open
  if (!modalIsOpen) {
    e.preventDefault();

    // If has error
    if (!checkFields()) return;
  }
  // Open modal
  triggerModal(modalIsOpen);
};

// Submit form
check.onclick = async () => {
  // Check if cart is updated
  const cart = await fetchCart();
  if (JSON.stringify(window.riceburritoCart) !== JSON.stringify(cart)) {
    alert("The cart is updated.");
    window.location.reload();
  } else {
    submit.click();
  }
};

// Valid input value
const checkFields = () => {
  let check = true;
  if (inputStoreId.value === "") {
    storeCardsInvalidText.style.display = "block";
    check = false;
  }
  if (inputPickupDateTime.value === "") {
    storeTimeInvalidText.style.display = "block";
    check = false;
  }
  return check;
};

// Render store card
const showStoreCard = (stores) => {
  let output = "";
  for (let i = 0; i < stores.length; i++) {
    let store = stores[i];
    let storeStatus = store.status === 1 || store.status === 4;
    output += `<div class="store-card ${storeStatus ? "" : "inactive"}"\
          data-store-id="${store.id}"\
          data-store-name="${store.name}"\
          data-store-address="${store.address}"\
          data-max-weight="${store.max_weight}">\
        <div class="store-card-status">\
          <div class="dot"></div>\
          <span class="store-card-status-badge ${
            storeStatus ? "active" : "inactive"
          }">\
            ${statusCodeToText(store.status)}
          </span>\
        </div>\
        <div class="store-card-name">\
          ${store.name}
        </div>\
        <div class="store-card-address">\
          ${store.address}
        </div>\
        <div class="store-card-phone">\
        ${store.phone}
        </div>\
      </div>`;
  }
  storeCards.innerHTML = output;
};

const statusCodeToText = (status) => {
  switch (status) {
    case 1:
    case 4:
      return "接受訂單 (Store available)";
      break;
    case 2:
      return "永久停業 (Permanently closed)";
      break;
    case 3:
      return "暫不接單 (Temporarily unavailable)";
      break;
    case 5:
      return "暫不接單 (Temporarily unavailable)";
      break;
    default:
      return "";
      break;
  }
};

// Toggle class of "active" on cards, and class of "show" on transactions.
const toggleCardsActive = (stores) => {
  let cardsList = document.querySelectorAll(".store-card");
  for (let i = 0; i < cardsList.length; i++) {
    if (cardsList[i].className.includes("inactive")) {
      continue;
    }
    cardsList[i].addEventListener("click", async function (e) {
      let storeId = this.getAttribute("data-store-id");
      let storeName = this.getAttribute("data-store-name");
      let storeAddress = this.getAttribute("data-store-address");
      let storeMaxWeight = this.getAttribute("data-max-weight");
      // If choose same card, do nothing
      if (storeId === inputStoreId.value) {
        return;
      }
      storeTimeGroup.removeEventListener("click", alertChooseStore);
      for (let n = 0; n < cardsList.length; n++) {
        if (cardsList[n].classList.contains("active")) {
          cardsList[n].classList.remove("active");
        }
      }
      this.classList.add("active");
      inputStoreId.value = storeId;
      inputStoreName.value = storeName;
      inputStoreAddress.value = storeAddress;
      inputMaxWeight.value = storeMaxWeight;
      getStoreTime(stores, storeId);
    });
  }
  if (cardsList.length === 1) {
    document.querySelector(".store-card ").dispatchEvent(new Event("click"));
  }
};

const displaySoldOut = (isSoldOut) => {
  if (isSoldOut) {
    storeTimeSelect.style.display = "none";
    submit.style.display = "none";
    storeSoldOutText.style.display = "block";
  } else {
    storeTimeSelect.style.display = "block";
    submit.style.display = "block";
    storeSoldOutText.style.display = "none";
  }
};

const displayExceedMaxWeight = (isExceedMaxWeight) => {
  if (isExceedMaxWeight) {
    storeExceedMaxWeightText.style.display = "block";
    storeSoldOutText.style.display = "none";
  } else {
    storeExceedMaxWeightText.style.display = "none";
  }
};

const getStoreTime = (stores, storeId = inputStoreId.value) => {
  // Clear input store date
  inputPickupDateTime.value = "";

  if (!storeId) return;

  // Get store info
  const STORE_INFO = stores.find((x) => x.id == storeId).storeInfo;
  const STORE_ACTIVE = STORE_INFO.active;
  const STORE_START_TIME = moment(
    moment().format("YYYY-MM-DD ") + STORE_INFO.start
  );
  const STORE_END_TIME = moment(
    moment().format("YYYY-MM-DD ") + STORE_INFO.end
  );

  storeSoldOutPreoderText.innerText =
    "Sold out (preorder starts at " +
    STORE_END_TIME.add(60, "minutes").format("hh:mma") +
    ")";

  // Get now tim
  const NOW_TIME = moment();
  // For test
  // const NOW_TIME = moment("2023-01-04 09:40");

  const IS_DURNING_OPEN_TIME =
    STORE_ACTIVE === "true" &&
    NOW_TIME.isBetween(STORE_START_TIME, STORE_END_TIME);

  // Get Store Time
  fetch(`${API_BASE}/api/stores/${storeId}/times`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      products: window.riceburritoCart,
    }),
  })
    .then((response) => response.json())
    .then((res) => {
      showStoreTime(res.weight, res.data);
      storeTimeSelect.removeAttribute("disabled");
      inputTotalWeight.value = res.weight;
      storeCardsInvalidText.style.display = "none";
      // disableTimeDurningOpenTime(IS_DURNING_OPEN_TIME, "2023-01-05 09:30");
      disableTimeDurningOpenTime(IS_DURNING_OPEN_TIME, res.data[0].time);
    });
};

const disableTimeDurningOpenTime = (is_durning_open_time, storeFirstTime) => {
  // 如果現在是營業時間且取得的第一個時間不是今天則不能選取
  if (is_durning_open_time && !moment(storeFirstTime).isSame(moment(), "d")) {
    storeTimeSelect.style.display = "none";
    submit.style.display = "none";
    storeSoldOutPreoderText.style.display = "block";
    return;
  } else {
    storeTimeSelect.style.display = "block";
    submit.style.display = "block";
    storeSoldOutPreoderText.style.display = "none";
    storeSoldOutPreoderText.innerText = "";
  }
};

// Render store time select
const showStoreTime = (totalWeight, stores) => {
  const isExceedMaxWeight = totalWeight > inputMaxWeight.value;
  let isSoldOut = true;
  let output = "<option disabled selected>Select a time</option>";

  for (let i = 0; i < stores.length; i++) {
    let store = stores[i];
    if (totalWeight > store.weight || store.disable) {
      output += `<option disabled="disabled">${showDate(
        store.time
      )} - Sold out</option>`;
    } else {
      output += `<option value="${store.time}" >${showDate(
        store.time
      )}</option>`;
      isSoldOut = false;
    }
  }
  displaySoldOut(isSoldOut);
  displayExceedMaxWeight(isExceedMaxWeight);
  storeTimeSelect.innerHTML = output;
  storeTimeSelect.addEventListener("change", (event) => {
    inputPickupDateTime.value = event.target.value;
    inputPickupDate.value = moment(event.target.value).format("MM-DD");
    inputPickupTime.value = moment(event.target.value).format("hh:mm");
    storeTimeInvalidText.style.display = "none";
  });
};

function showDate(date) {
  const dateFormat = date.slice(0, 10);

  const tomorrow = moment().add(1, "days").format().slice(0, 10);

  if (tomorrow === dateFormat) {
    return "Tomorrow " + moment(date).format("HH:mm (MM/DD,ddd)");
  }

  const todayDate = moment().format().slice(0, 10);

  if (todayDate === dateFormat) {
    return "Today " + moment(date).format("HH:mm (MM/DD,ddd)");
  }

  return moment(date).format("MM/DD HH:mm (ddd)");
}

document.addEventListener("DOMContentLoaded", () => {
  // Get stores
  moment.tz.setDefault("America/Los_Angeles");
  (async () => {
    window.riceburritoCart = await fetchCart();
    const response = await fetch(`${API_BASE}/api/stores`)
      .then((response) => {
        return response.json();
      })
      .catch(() => {
        storePickup.innerHTML = `
          <span class="store-error-text">
            系統發生錯誤，請重新整理頁面或直接聯絡我們。
          </span>
          <br>
          <span class="store-error-text">
            Unexpected system error has occurred.
            Please refresh the page or contact us directly.
          </span>
        `;
        submit.style.display = "none";
      });
    const stores = response.data;
    showStoreCard(stores);
    toggleCardsActive(stores);
  })();
  // Add alert if user not choose store
  storeTimeGroup.addEventListener("click", alertChooseStore);
});
